// extracted by mini-css-extract-plugin
export default {"header":"Header_header__RDUGr","header-content":"Header_header-content__wwjWu"};